import sanitizeHtml from "sanitize-html";

export default function autoLink(str: string) {
  const regExp = /((https?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
  const regLink = '<a href="$1" target="_blank">$2</a>';
  return sanitizeHtml(str, { allowedTags: [] }).replace(regExp, regLink);
}
